<template>
  <div class="home">
    <v-card class="card">
      <v-icon color="foreground" x-large>mdi-cloud</v-icon>
      <h1>Configurações do Drive</h1>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'Home',
  components: { },
};
</script>
<style scoped>
  .home .card {
    margin: 0;
    text-align: center;
    border: none;
    box-shadow: none;
    background-color: var(--v-muted-base);
  }
</style>
